import { styled } from '@mui/system';
import { OutlinedInput } from '@mui/material';
import Search from '@mui/icons-material/Search';

export const StyledOutlinedInput = styled(OutlinedInput)(() => ({
  boxShadow: '0px 1px 2px rgb(0 0 0 / 16%), 0px 2px 4px rgb(0 0 0 / 12%), 0px 1px 8px rgb(0 0 0 / 10%)',
  borderRadius: 8,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.23) !important'
  }
}));

export const StyledSearchIcon = styled(Search)(() => ({
  color: '#757575'
}));
